import { useQuery } from '@tanstack/react-query';
import { fetchRevenueBreakdown, type RevenueBreakdownParams, type RevenueBreakdownItem } from '../services/revenueBreakdownService';

export function useRevenueBreakdown(params: RevenueBreakdownParams) {
  return useQuery<RevenueBreakdownItem[], Error>({
    queryKey: ['revenueBreakdown', params],
    queryFn: () => fetchRevenueBreakdown(params),
    staleTime: 1000 * 60 * 5,
    enabled: !!params.start_date && !!params.end_date,
  });
}
